import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ConnectionService } from '@services/connection-service';
import { AppConfig } from '../../../app.config';
import { LanguageChangeComponent } from '@shared/bottom-sheet-layouts/language-change/language-change.component';
import { EventLoggerService } from '@services/event-logger-service';

const REGIMEN_IMG_BACKGROUND = {
  variant_1499: 'tw-bg-teal-100',
  variant_4999: 'tw-bg-blue-100',
  variant_999: 'tw-bg-teal-100',
  variant_1999: 'tw-bg-orange-100',
};
@Component({
  selector: 'app-voice-note-banner',
  templateUrl: './voice-note-banner.component.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class VoiceNoteBannerComponent implements OnInit {
@Input('docImg') docImg:string;
@Input('voiceUrl') voiceUrl:string;
@Input('trackEventAudio') trackEventAudio:any;
@Input('OrderApproval') OrderApproval:any;
@Output('trackVoiceEvent') trackVoiceEvent:EventEmitter<any> = new EventEmitter();
@Output('languageChanged') languageChanged:EventEmitter<void> = new EventEmitter();
@Input('swiperCardsBanner') swiperCardsBanner:any;
@Input('message') message:string;
@Input('isDoctorVerifiedKit') isDoctorVerifiedKit?: boolean;
@Input('regimen') regimen?: any;
@Input('doctorName') doctorName?: string;
@Input('kitImageUrl') kitImageUrl?: string;
@Input('orderChatId') orderChatId?: string;
regimenCoverBgColor: string = '';
user: any;
currentCommunicationLanguageCode: string = '';
languageUpdatedDisplayName: string = '';
isEnHiLanguageUpdate: boolean = false;
private languageUpdatedTimer: ReturnType<typeof setTimeout>;

constructor(
  private readonly bottomSheet: MatBottomSheet,
  private readonly conn: ConnectionService,
  public appConfig: AppConfig,
  private readonly eventLoggerService: EventLoggerService,
) {}

get isAppLanguageEnglish(): boolean {
  return this.user?.get('languagePreference') === this.appConfig.Shared.Languages.EN;
}

ngOnInit(): void {
  this.user = this.conn.getActingUser();
  this.currentCommunicationLanguageCode = this.user?.get('communicationLanguagePreference') || this.appConfig.Shared.Languages.EN;
  this.setRegimenCoverBackgroundColor();
}

handleClick(event:any):void {
  this.trackVoiceEvent.emit(event);
}

openLanguageChangeDrawer(): void {
  this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'voice-note-language-change-pill' }));
  const ref = this.bottomSheet.open(LanguageChangeComponent, {
    data: {
      translateChatMessages: false,
      skipNavigation: true,
      isCommunicationLanguage: true,
      allowedLanguageCodes: [
        this.appConfig.Shared.Languages.EN,
        this.appConfig.Shared.Languages.HI,
        this.appConfig.Shared.Languages.MR,
        this.appConfig.Shared.Languages.TE,
      ],
      currentLanguageCode: this.currentCommunicationLanguageCode,
      title: $localize`:@@chooseDoctorVoiceNoteLanguage:Choose doctor voice note language`,
      confirmLabel: $localize`:@@update:Update`,
    },
  });
  ref.afterDismissed().subscribe(async (selected: { code: string, displayName: string } | undefined) => {
    if (!selected) return;
    try {
      await this.conn.changeUserCommunicationLanguage(selected.code);
      this.currentCommunicationLanguageCode = selected.code;
      clearTimeout(this.languageUpdatedTimer);

      const enHiLanguages = [this.appConfig.Shared.Languages.EN, this.appConfig.Shared.Languages.HI];
      this.isEnHiLanguageUpdate = enHiLanguages.includes(selected.code);
      this.languageUpdatedDisplayName = selected.displayName;

      if (this.orderChatId) {
        await this.conn.translateVoiceNote(this.orderChatId);
      }

      this.languageUpdatedTimer = setTimeout(() => {
        this.languageUpdatedDisplayName = '';
        this.languageChanged.emit();
      }, 3000);
    } catch (_) {
      this.languageUpdatedDisplayName = '';
    }
  });
}

setRegimenCoverBackgroundColor(): void {
  const regimenVariantId = this?.regimen?.selectedVariantId;
  this.regimenCoverBgColor = REGIMEN_IMG_BACKGROUND[regimenVariantId] || REGIMEN_IMG_BACKGROUND.variant_1499;
}
}